import Param from '../param';
let param = new Param();

/* -------------------------------------------------------------------------

    --  [ ※ボディの背景にあるもので自動でアニメーションさせるもの ]

------------------------------------------------------------------------- */

export default class autoAnimationManager {
    constructor(){


    }

    car($target,inc){

        // let tl = new TimelineLite();

        if(!$target.hasClass("is-back")){
            // TweenMax.set($target,{ opacity:1 });
            TweenMax.to($target, 5.6,
                {
                    y:-inc,
                    ease: Power1.easeInOut,
                    onComplete:function () {
                        // TweenMax.set($target,{ opacity:0 });
                        $target.addClass("is-back");
                        setTimeout(function () {
                            $target.parent(".js__tsc").removeClass("is-show")
                        },15e2);
                    }
                    // filter:"blur(0px)",
                    // ease: "Power2.easeOut",
                }
            );
        }else{
            // TweenMax.set($target,{ opacity:1 });
            TweenMax.to($target, 5.6,
                {
                    y:0,
                    ease: Power1.easeInOut,
                    onComplete:function () {
                        $target.addClass("is-front");
                        // TweenMax.set($target,{ opacity:0 });
                        setTimeout(function () {
                            $target.removeClass("is-front").removeClass("is-back");
                            $target.parent(".js__tsc").removeClass("is-show")
                        },15e2);
                    }
                    // filter:"blur(0px)",
                    // ease: "Power2.easeOut",
                }
            );
        }



    }
    airplane($target,inc){


        TweenMax.fromTo($target, 10.6 / $target.data("speed"),
            {
                y:inc/8,
                z:1,
            },
            {
                y:-inc*1.6,
                z:0,
                ease: Power1.easeInOut,
                onComplete:function () {
                    setTimeout(function () {
                        $target.parent(".js__tsc").removeClass("is-show")
                    },15e2);
                }
            }
        );
    }


}
